<!--
 * @Description: 内部单位结算
 * @Autor: luzx
 * @Date: 2023-05-16 09:21:19
 * @LastEditors: luzx
 * @LastEditTime: 2023-05-16 09:21:19
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <!-- 导航 -->
        <div class="tabtop">
          <div v-for="(item, index) in navlist" :key="index" @click="choose(item.id)">
            <div :class="currenindex == index + 1 ? 'active' : 'text'">{{ item.value }}</div>
            <div v-if="currenindex !== index + 1 && currenindex !== index + 2 && index !== 2" class="hr"></div>
          </div>
        </div>
        <!-- 搜索条件 -->
        <div>
          <el-collapse-transition>
            <div v-show="showCardNav" style="padding-top: 18px">
              <el-form v-if="currenindex !== 3" :inline="true" label-width="110px">
                <!-- <el-form-item v-if="currenindex == 1 || currenindex == 2">
                  <span slot="label">内部单位合同</span>
                  <el-input v-model="templateSelection" placeholder="请输入" clearable style="width:400px ;"></el-input>
                </el-form-item> -->
                <el-form-item>
                  <span slot="label">内部单位合同</span>
                  <div v-if="currenindex == 1 || currenindex == 2" style="width: 240px; height: 36px; display: flex">
                    <div :title="templateSelection" style="width: 300px; padding: 0 10px; border-bottom: 1px solid #bbb; margin-right: 5px" class="ellipsis">{{ templateSelection }}</div>
                    <el-button class="bottom_all_two" @click="internalListDio">选择</el-button>
                  </div>
                </el-form-item>
                <!-- <el-form-item>
                  <el-button size="medium" class="bottom_all" @click="internalListDio">选择</el-button>
                </el-form-item> -->
                <el-form-item>
                  <span slot="label"><span style="color: red">* </span>结算时间段</span>
                  <el-date-picker
                    v-model="datePicker"
                    style="height: 36px"
                    type="datetimerange"
                    unlink-panels
                    align="right"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), pagesgettableData()">查 询</el-button>
                  <el-button v-if="currenindex != 3" size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
                  <el-button v-if="currenindex == 1" style="margin-left: 12px" size="small" class="bottom_one" @click="unitsettlement"> 生成结算单 </el-button>
                  <!-- <el-dropdown :hide-on-click="false" trigger="click" style="margin-left: 12px">
                    <el-button v-if="currenindex == 1" size="medium" class="bottom_one">生成结算单</el-button>
                    <el-dropdown-menu slot="dropdown" style="text-align: left">
                      <el-dropdown-item>
                        <el-button style="margin: 5px 0" class="bottom_one" size="mini" @click="unitsettlement(1)">
                          混凝土购销</el-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button size="mini" style="margin: 5px 0" class="bottom_one"
                          @click="unitsettlement(2)">混凝土代加工</el-button>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown> -->
                  <!-- <el-button v-if="currenindex == 1"
                    style="margin-left: 12px" size="small" class="bottom_three"
                    :disabled="generate.logisticsList.length == 0" @click="statements"> 生成结算单 </el-button> -->
                </el-form-item>
              </el-form>
              <el-form v-if="currenindex == 3" :inline="true" label-width="110px">
                <el-form-item>
                  <span slot="label">结算单编号</span>
                  <el-input v-model="tableParam.balanceNo" placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item v-if="currenindex == 3">
                  <span slot="label">内部单位合同</span>
                  <div style="width: 240px; height: 36px; display: flex">
                    <div :title="templateSelection" style="width: 300px; padding: 0 10px; border-bottom: 1px solid #bbb; margin-right: 5px" class="ellipsis">{{ templateSelection }}</div>
                    <el-button class="bottom_all_two" @click="internalListDio">选择</el-button>
                  </div>
                </el-form-item>
                <el-form-item>
                  <span slot="label">提交时间</span>
                  <el-date-picker
                    v-model="senddatePicker"
                    style="height: 36px"
                    type="datetimerange"
                    unlink-panels
                    align="right"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableDataex()">查 询</el-button>
                  <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <!-- <div v-show="currenindex == 1" class="card_nav">
              <div>
              </div>
              <div></div>
            </div> -->
            <div v-if="currenindex == 1" class="card_info" style="padding: 10px 20px; color: red; font-weight: bold">勾选的数据不参与结算，生成结算单的数据为所有未勾选的数据。</div>
            <div v-loading="tableLoading" class="card_info">
              <el-table
                ref="table"
                :header-cell-style="{ background: '#f3f6f9' }"
                :cell-style="{ borderRight: 'none' }"
                border
                stripe
                style="width: 100%"
                :height="screenHeight - 390"
                :data="tableData"
                tooltip-effect="dark"
                @selection-change="pageshandleSelectionChange"
              >
                <el-table-column v-if="currenindex == 1" align="center" type="selection"></el-table-column>
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :min-width="item.width">
                    <template slot-scope="scope">
                      <span v-if="item.label == '结算时间段'" width="500px"> {{ scope.row.settleStartTime }} - {{ scope.row.settleEndTime }} </span>
                      <div v-else-if="item.label == '结算单编号'" class="table_link">
                        <!-- <el-dropdown :hide-on-click="false" trigger="click" style="margin-left: 12px"> -->
                        <!-- <el-button v-if="currenindex == 1" size="medium" class="bottom_one">{{ scope.row[item.prop] }}</el-button> -->
                        <span @click="show(scope.row)">{{ scope.row[item.prop] }}</span>
                        <!-- <el-dropdown-menu slot="dropdown" style="text-align: left">
                            <el-dropdown-item>
                              <el-button style="margin: 5px 0" class="bottom_one" size="mini" @click="show(scope.row, 1)">
                                混凝土购销</el-button>
                            </el-dropdown-item>
                            <el-dropdown-item>
                              <el-button size="mini" style="margin: 5px 0" class="bottom_one"
                                @click="show(scope.row, 2)">混凝土代加工</el-button>
                            </el-dropdown-item>
                          </el-dropdown-menu> -->
                        <!-- </el-dropdown> -->
                      </div>
                      <span v-else-if="item.label == '内部单位合同'" width="500px"> {{ scope.row.code }}_{{ scope.row.firstParty }}_{{ scope.row.secondParty }} </span>
                      <span v-else-if="item.label == '内部审核状态'">
                        <span v-if="scope.row.auditStatus == 1">待提交</span>
                        <span v-else-if="scope.row.auditStatus == 2">审核中</span>
                        <span v-else-if="scope.row.auditStatus == 3">通过</span>
                        <span v-else-if="scope.row.auditStatus == 4">未通过</span>
                      </span>
                      <span v-else-if="item.label == '操作'">
                        <el-button
                          v-if="scope.row.auditStatus == 1 || scope.row.auditStatus == 4"
                          size="mini"
                          class="bottom_all_two"
                          @click="$router.push({ name: 'sign_internalunit', query: { dataContent: JSON.stringify({ id: scope.row.id }), type: 1, contractType: scope.row.contractTypeId } })"
                          >提交审核</el-button
                        >
                        <!-- <el-button
                          v-if="scope.row.auditStatus == 3 && (scope.row.supplierConfirm == 0 || scope.row.supplierConfirm == 1)"
                          size="mini" class="bottom_all_two" @click="userSubmit(scope.row)"> 发送 </el-button> -->
                        <el-button size="mini" class="bottom_all_two" @click="delHandler(scope.row)">删除</el-button>
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000, '全部']"
            layout="prev,pager,slot,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableDataex()"
          >
            <el-select v-model="curElPage" class="pageSelectContainer" placeholder="请选择" size="mini" @change="changeSizes">
              <el-option v-for="item in optionsPage" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableDataex()">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 原物料-待结算-生成结算单 -->
    <el-dialog :visible.sync="billDeta" width="1180px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">内部单位结算单</span>
      <div ref="html" style="padding: 10px 20px">
        <div class="bill_top">
          <span><span class="text">甲方单位：</span>{{ contract.firstParty }}</span>
          <span><span class="text">乙方单位：</span>{{ contract.secondParty }}</span>
          <span><span class="text">结算时间段：</span>{{ statements.settleStartTime ? statements.settleStartTime.split(" ")[0] : "-" }}至{{ statements.settleEndTime ? statements.settleEndTime.split(" ")[0] : "-" }}</span>
          <span><span class="text">结算单编号：</span>{{ statements.balanceNo }}</span>
        </div>
        <!-- <div class="bill_top">
          
        </div> -->
        <div class="bill_title1">产品结算</div>
        <template v-for="(item, index) in billDetails">
          <div v-if="createtype == 1" :key="index">
            <div class="bill_subtitle">
              <span
                ><span class="text">{{ item.contractName }}</span></span
              >
            </div>
            <el-table :key="index" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="item.data" tooltip-effect="dark">
              <el-table-column label="时间段" align="center" width="175">
                <template slot-scope="scope"> {{ scope.row.settleStartTime ? scope.row.settleStartTime.split(" ")[0] : "-" }} - {{ scope.row.settleEndTime ? scope.row.settleEndTime.split(" ")[0] : "-" }} </template>
              </el-table-column>
              <el-table-column label="产品名称" align="center" prop="productName" width="auto"></el-table-column>
              <el-table-column label="签收数量（方）" align="center" width="auto">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.quantity" onchange="if(!value)value=0" placeholder="请输入" style="width: 100%" disabled onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="产品单价（元/m³）" align="center" width="auto">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.productPrice" onchange="if(!value)value=0" placeholder="请输入" style="width: 100%" disabled onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="增加金额（元）" align="center" width="auto">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.addPrice"
                    disabled
                    onchange="if(!value)value=0"
                    placeholder="请输入"
                    style="width: 100%"
                    onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                    @input="scope.row.increaseAmount = $regExp.checkNum(scope.row.increaseAmount)"
                    @blur="scope.row.increaseAmount = $regExp.blurCheckNum(scope.row.increaseAmount)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="结算金额（元）" align="center" width="auto" disabled>
                <template slot-scope="scope">
                  {{ Math.round((Number(scope.row.productPrice || 0) + Number(scope.row.addPrice || 0)) * Number(scope.row.quantity) * 100) / 100 }}
                </template>
              </el-table-column>
            </el-table>
            <div style="border-top: 0px" class="combined">小计：签收数量【{{ combined(item.data) }}】方，结算金额【{{ combined2(item.data) }}】元</div>
          </div>
        </template>
        <template>
          <div v-if="createtype == 2">
            <!-- <div class="bill_subtitle">
              <span><span class="text">{{ item.contractName }}</span></span>
            </div> -->
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billDetails" tooltip-effect="dark">
              <el-table-column label="生产站点" align="center" width="auto">
                <template slot-scope="scope">
                  <span>{{ scope.row.contractName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="签收数量（方）" align="center" width="auto">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.quantity" onchange="if(!value)value=0" placeholder="0" style="width: 100%" disabled onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="加工费（元/m³）" align="center" width="auto">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.processPrice" onchange="if(!value)value=0" placeholder="0" style="width: 100%" disabled onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="结算金额（元）" align="center" width="auto">
                <template slot-scope="scope">
                  {{ Math.round(Number(scope.row.quantity || 0) * Number(scope.row.processPrice || 0) * 100) / 100 }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
        <!-- 特殊条款 -->
        <div class="bill_title1">特殊条款描述</div>
        <div>{{ contract.contractClause }}</div>
        <!-- 调整金额 -->
        <div class="bill_title">
          调整金额
          <el-button v-show="cansave" size="mini" class="bottom_all" style="margin-left: 24px" @click="addItem1()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="deductionList" tooltip-effect="dark">
          <el-table-column label="站点" align="center">
            <template slot-scope="scope">
              <el-select ref="stationName" v-model="scope.row.stationId" style="width: 100%" placeholder="请选择站点" @change="changeStation(scope.row.stationId)">
                <el-option v-for="item in stationList" :key="item.stationId" :label="item.station" :value="item.stationId"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column v-if="createtype == 1" label="工程名称" align="center">
            <template slot-scope="scope">
              <el-select ref="type" v-model="scope.row.engineeringId" style="width: 100%" placeholder="请选择" :disabled="!cansave">
                <el-option v-for="(item, index) in engineeringList" :key="index" :label="item.engineeringName" :value="item.engineeringId" @click.native="scope.row.engineeringName = item.engineeringName"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="产品名称" align="center" prop="productName">
            <template slot-scope="scope">
              <el-input v-model="scope.row.productName" placeholder="请输入" :disabled="!cansave" style="width: 100%" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="产品单价" align="center" prop="productPrice">
            <template slot-scope="scope">
              <el-input v-model="scope.row.productPrice" placeholder="请输入"
                style="width: 100%"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                :disabled="!cansave"
                @input="scope.row.productPrice = $regExp.checkNum(scope.row.productPrice)"
                @blur="scope.row.productPrice = $regExp.blurCheckNum(scope.row.productPrice) ,getaAjustMoney(scope.$index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="调整量" align="center" prop="adjustCount">
            <template slot-scope="scope">
              <el-input v-model="scope.row.adjustCount" placeholder="请输入"
                style="width: 100%"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                :disabled="!cansave"
                @input="scope.row.adjustCount = $regExp.checkNum(scope.row.adjustCount)"
                @blur="scope.row.adjustCount = $regExp.blurCheckNum(scope.row.adjustCount),getaAjustMoney(scope.$index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="调整类型" align="center">
            <template slot-scope="scope">
              <el-select ref="deductionType1" v-model="scope.row.adjustModule" :disabled="!cansave" style="width: 100%" placeholder="请选择调整类型" @change="changedeductionType(scope.row.adjustModule)">
                <el-option v-for="item in deductionTypes" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调增/调减" align="center" prop="type">
            <template slot-scope="scope">
              <el-select ref="type" v-model="scope.row.type" style="width: 100%" placeholder="请选择" :disabled="!cansave">
                <el-option :key="1" label="调增" :value="0"></el-option>
                <el-option :key="2" label="调减" :value="1"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调整金额" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.adjustMoney"
                placeholder="请输入"
                style="width: 100%"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                :disabled="!cansave"
                @input="scope.row.adjustMoney = $regExp.checkNum(scope.row.adjustMoney)"
                @blur="scope.row.adjustMoney = $regExp.blurCheckNum(scope.row.adjustMoney)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="是否影响开票" align="center">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.isInvoice" :disabled="!cansave">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" placeholder="请输入" :disabled="!cansave" style="width: 100%" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="cansave" label="操作" align="left" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="delItem1(scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="border-top: 0px" class="combined">小计：结算金额【{{ combined3(1) }}】元</div>
        <!-- 结算合计 -->
        <div class="bill_title">结算合计</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="totalList" tooltip-effect="dark">
          <el-table-column label="甲方单位" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.firstParty }}</div>
            </template>
          </el-table-column>
          <el-table-column label="乙方单位" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.secondParty }}</div>
            </template>
          </el-table-column>
          <el-table-column label="产品费用（元）" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.money ? scope.row.money : "---" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="调整金额（元，不影响开票）" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.noAdjustCost ? scope.row.noAdjustCost : "---" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="调整金额（元，影响开票）" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.isAdjustCost ? scope.row.isAdjustCost : "---" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="结算金额（元）" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.totalCost ? scope.row.totalCost : "---" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="开票金额（元）" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.ticketCost ? scope.row.ticketCost : "---" }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer" style="display: flex; justify-content: space-between">
        <div v-if="daochuFlag">
          <el-button class="bottom_all" @click="outHandler(createtype)">导出</el-button>
        </div>
        <div></div>
        <div>
          <el-button
            class="bottom_all_two"
            @click="
              billDeta = false;
              deductionList = [];
            "
            >关 闭</el-button
          >
          <el-button v-if="this.cansave" class="bottom_all" style="margin-left: 24px" :loading="!saveFlag" @click="combinedSubmit()">保 存</el-button>
        </div>
      </span>
    </el-dialog>
    <!-- 内部单位合同查询选择列表 -->
    <el-dialog :visible.sync="inetrnalDio" width="960px" :close-on-click-modal="false" :append-to-body="true">
      <span slot="title" class="dialog-title">内部单位合同</span>
      <div class="dialoginfo">
        <el-table
          ref="senderDigTable"
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="intervalchooselist"
          highlight-current-row
          tooltip-effect="dark"
          @row-click="singleElection"
        >
          <el-table-column align="center" width="55" label="选择">
            <template slot-scope="scope">
              <el-radio v-model="tableParam.internalContractId" class="radio" :label="scope.row.id">&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column label="合同类型" align="center" prop="contractTypeId">
            <template slot-scope="scope">
              <span v-if="scope.row.contractTypeId == 1">购销</span>
              <span v-if="scope.row.contractTypeId == 2">代加工</span>
            </template>
          </el-table-column>
          <el-table-column label="甲方单位" align="center" prop="firstParty"></el-table-column>
          <el-table-column label="乙方单位" align="center" prop="secondParty"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="inetrnalDio = false">取 消</el-button>
        <el-button class="bottom_al asda l" style="margin-left: 24px" @click="confirmChoose">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="inetrnalDio2" width="960px" :close-on-click-modal="false" :append-to-body="true">
      <span slot="title" class="dialog-title">内部单位合同</span>
      <div class="dialoginfo">
        <el-table
          ref="senderDigTable"
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="intervalchooselist"
          highlight-current-row
          tooltip-effect="dark"
          @row-click="singleElection"
        >
          <el-table-column align="center" width="55" label="选择">
            <template slot-scope="scope">
              <el-radio v-model="tableParam.contractId" class="radio" :label="scope.row.id">&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column label="合同类型" align="center" prop="contractTypeId">
            <template slot-scope="scope">
              <span v-if="scope.row.contractTypeId == 1">购销</span>
              <span v-if="scope.row.contractTypeId == 2">代加工</span>
            </template>
          </el-table-column>
          <el-table-column label="甲方单位" align="center" prop="firstParty"></el-table-column>
          <el-table-column label="乙方单位" align="center" prop="secondParty"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="inetrnalDio2 = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="confirmChoose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  queryPage1,
  queryPage2,
  queryPage3,
  get_list_unitinternal,
  create_unitinternal, //生产结算单
  save_unitinternal, //保存结算单
  look_unitinternal, //查看结算单
  saveAlreadyFine,
  deleteInnerSettle,
  Downloadgx,
  Downloaddjg,
} from "@/api/wise/internalunit.js";
import { _debounce } from "@/utils/utils.js";
import { post } from "@/api/table.js";
export default {
  mixins: [mixin],
  data() {
    return {
      //分页
      optionsPage: [
        {
          label: "10条/页",
          value: 10,
        },
        {
          label: "20条/页",
          value: 20,
        },
        {
          label: "30条/页",
          value: 30,
        },
        {
          label: "40条/页",
          value: 40,
        },
        {
          label: "50条/页",
          value: 50,
        },
        {
          label: "100条/页",
          value: 100,
        },
        {
          label: "200条/页",
          value: 200,
        },
        {
          label: "500条/页",
          value: 500,
        },
        {
          label: "1000条/页",
          value: 1000,
        },
        {
          label: "全部",
          value: 100000,
        },
      ],
      curElPage: 10, //默认每页显示20条
      receivingUnitType: false,
      ReceivingUnitList: [],
      typelist: [],
      daYinForm: { list: [], receivingUnit: "请选择" },
      daYinFormFor: [], //打印for循环数据
      daYinType: false,
      companyId: "",
      company: "",
      companylist: [],
      stationId: "",
      stationName: "",
      stationIdlist: [],
      /*表格增删改查及下载接口*/
      queryPage: "",
      /*表格数据*/
      table: [],
      table1: [
        { label: "小票类型", width: "200", prop: "productType", status: true },
        { label: "工程名称", width: "200", prop: "engineeringName", status: true },
        { label: "工程合同签订主体", width: "100", prop: "firstParty", status: true },
        { label: "生产站点", width: "120", prop: "proStation", status: true },
        { label: "外协合同签订主体", width: "120", prop: "firstPartyOut", status: true },
        { label: "产品名称", width: "100", prop: "productName", status: true },
        { label: "票面量(方)", width: "100", prop: "faceValue", status: true },
        { label: "签收量(方)", width: "100", prop: "quantity", status: true },
        { label: "票面时间", width: "160", prop: "affirmTime", status: true },
        // { label: "产品单价（元/方）", width: "140", prop: "unitPrice", status: true },
        // { label: "混凝土生产费用(元)", width: "140", prop: "productCost", status: true }
      ],
      table2: [
        { label: "结算单编号", width: "200", prop: "balanceNo", status: true },
        { label: "内部单位合同", width: "160", prop: "code,firstParty,secondParty", status: true },
        { label: "结算时间段", width: "200", prop: "settleStartTime,settleEndTime", status: true },
        { label: "结算总金额（元）", width: "140", prop: "totalCost", status: true },
        { label: "提交时间", width: "160", prop: "createTime", status: true },
        { label: "内部审核状态", width: "120", prop: "auditStatus", status: true },
        { label: "操作", width: "120", prop: "", status: true },
      ],
      table3: [
        { label: "小票类型", width: "200", prop: "ticketType", status: true },
        { label: "工程名称", width: "200", prop: "engineeringName", status: true },
        { label: "工程合同签订主体", width: "100", prop: "contractSubject", status: true },
        { label: "生产站点", width: "120", prop: "stationName", status: true },
        { label: "外协合同签订主体", width: "120", prop: "outerContractSubject", status: true },
        { label: "产品名称", width: "100", prop: "productName", status: true },
        { label: "票面量(方)", width: "100", prop: "faceValue", status: true },
        { label: "签收量(方)", width: "100", prop: "signValue", status: true },
        { label: "票面时间", width: "160", prop: "faceTime", status: true },
        // { label: "产品单价（元/方）", width: "140", prop: "unitPrice", status: true },
        // { label: "混凝土生产费用(元)", width: "140", prop: "productCost", status: true }
      ],
      pagesType: 0,
      /**导航栏*/
      navlist: [
        {
          value: "待结算",
          id: 1,
        },
        {
          value: "已结算",
          id: 2,
        },
        {
          value: "结算单",
          id: 3,
        },
      ],
      currenindex: 1,
      datePicker: [],
      searchText: "",
      search: false,
      searchData: [],
      searchradio: "",
      cooperativeUnit: [],
      stations: [],
      rawId: [],
      contractId: [],
      generate: {
        logisticsList: [],
        clearingSourceId: "",
        startTime: "",
        endTime: "",
        contractId: "",
      },
      deductionTypes: [
        { itemName: "产品费用", id: "1" },
        { itemName: "特殊条款", id: "2" },
        { itemName: "调整金额", id: "3" },
      ],
      /*结算单*/
      billDeta: false,
      billDetails: [],
      billList: [{}],
      sendersList: [],
      senderDigList: [],
      selectSendersList: [],
      sendersDig: false,
      spanArr: {},
      pos: "",
      deductionList: [],
      deductionListCopy: [],
      totalListCopy: [],
      /**查看阶段单*/
      billDeta1: false,
      UserInfo: {},
      billDetails1: { list: [] },
      userDeta: false,
      useroptons: [],
      userarr: [],
      cooperativeUnitArr: [], //调整金额-协作单位
      supplierNameSearch: "", //供应商弹窗筛选
      noPass: false, //审核状态未通过
      inetrnalDio: false,
      inetrnalDio2: false,
      intervalchooselist: [],
      templateSelection: "", //选择的id
      intervalchooseitem: {},
      selectItemList: [], //选择的项
      contract: {},
      statements: {},
      createtype: 1,
      allmoneyDate: [],
      totalList: [
        {
          firstParty: "",
          secondParty: "",
          money: 0,
          noAdjustCost: 0,
          isAdjustCost: 0,
          totalCost: 0,
          ticketCost: 0,
        },
      ],
      cansave: true,
      daochuFlag: false,
      downloadId: "",
      pageAll: [],
      contractTypeId: "",
      stationList: [],
      resAllList: [],
      saveFlag: true,
      engineeringList: [],
    };
  },
  async created() {
    // const { data } = await getDicType({ code: "deductionType" });
    // this.deductionTypes = data.items;
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam.pageSize = this.curElPage;
    this.tableParam = { ...this.tableParam, internalContractId: "", startProTime: "", endProTime: "" };

    get_list_unitinternal({ page: 1, pageSize: 10 }).then(res => {
      this.intervalchooselist = res.data.data;
    });
  },
  watch: {
    currenindex: {
      handler() {
        this.tableData = [];
        this.datePicker = [];
        this.templateSelection = "";
        this.tableParam = this.$options.data().tableParam;
        this.init();

        if (this.currenindex == 1) {
          this.curElPage = 10;
          this.tableParam.pageSize = 10;
          this.queryPage = queryPage1;
          this.table = this.table1;
          if (this.datePicker && this.datePicker.length !== 0) {
            this.gettableDataex();
          }
          // this.$message({
          //   message: "提示哦~请先选择结算时间段后进行数据展示",
          //   type: "info",
          // });
        }
        if (this.currenindex == 2) {
          this.curElPage = 10;
          this.tableParam.pageSize = 10;
          this.table = this.table3;
          this.queryPage = queryPage2;
          if (this.datePicker && this.datePicker.length !== 0) {
            this.gettableData();
          }
          // this.$message({
          //   message: "提示哦~请先选择结算时间段后进行数据展示",
          //   type: "info",
          // });
        }
        if (this.currenindex == 3) {
          this.curElPage = 10;
          this.tableParam.pageSize = 10;
          this.table = this.table2;
          this.queryPage = queryPage3;
          this.gettableData();
        }
        //此处为执行的函数或者方法
      },
      deep: false, //是否深度监听，true为是，默认为false
      immediate: true, //immediate表示在watch中首次绑定的时候，是否执行handler,true为执行,默认为false
    },
    datePicker() {
      if (this.datePicker) {
        if (this.currenindex == 1) {
          this.tableParam.startProTime = this.datePicker[0];
          this.tableParam.endProTime = this.datePicker[1];
        } else if (this.currenindex == 2) {
          this.tableParam.settleStartTime = this.datePicker[0];
          this.tableParam.settleEndTime = this.datePicker[1];
        }
      } else {
        if (this.currenindex == 1) {
          this.tableParam.startProTime = "";
          this.tableParam.endProTime = "";
        } else if (this.currenindex == 2) {
          this.tableParam.settleStartTime = "";
          this.tableParam.settleEndTime = "";
        }
      }
    },
    senddatePicker() {
      if (this.senddatePicker) {
        this.tableParam.settleStartTime = this.senddatePicker[0];
        this.tableParam.settleEndTime = this.senddatePicker[1];
      } else {
        this.tableParam.settleStartTime = "";
        this.tableParam.settleEndTime = "";
      }
    },
    /**结算合计*/
    tatol: {
      handler() {
        this.settotalList();
      },
      deep: true,
      immediate: false,
    },
  },
  computed: {
    tatol() {
      return {
        billList: this.billList,
        deductionList: this.deductionList,
        billDetails: this.billDetails,
      };
    },
  },
  methods: {
    getaAjustMoney(index){
      this.deductionList[index].adjustMoney = Number(this.deductionList[index].productPrice || 0) * Number(this.deductionList[index].adjustCount || 0)
    },
    /*获取列表*/
    async gettableDataex() {
      this.tableLoading = true;
      await post(this.queryPage, this.tableParam).then(res => {
        if (res.code === 1001) {
          this.tableLoading = false;
          this.total = res.data.page.total;
          this.tableData = res.data.page.records;
          this.pageAll = res.data.pageAll.records;
          console.log(res.data);
        }
      });
    },
    changeStation(e) {
      console.log(e);
      let arr = this.stationList.filter(m => {
        if (m.stationId == e) {
          return true;
        }
      });
      console.log(arr);
      this.deductionList.forEach(n => {
        if (n.stationId == e) {
          n.station = arr[0].station;
        }
      });
      console.log(this.deductionList);
    },
    changedeductionType(e) {
      console.log(e);
      let arr = this.deductionTypes.filter(m => {
        if (m.id == e) {
          return true;
        }
      });
      this.deductionList.forEach(n => {
        if (n.adjustModule == e) {
          n.deductionType = arr[0].itemName;
        }
      });
      console.log(this.deductionList);
    },
    outHandler(type) {
      if (this.statements.field1 != 2) {
        this.$message({
          message: "数据正在处理，请稍后~",
          type: "warning",
        });
        return;
      }
      if (type == 1) {
        this.$Download(Downloadgx, { id: this.downloadId });
      } else if (type == 2) {
        this.$Download(Downloaddjg, { id: this.downloadId });
      }
    },
    delHandler(e) {
      console.log(e);
      if (e.field1 != 2) {
        this.$message({
          message: "数据正在处理，请稍后~",
          type: "warning",
        });
        this.gettableData();
        return;
      }
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          this.tableLoading = true;
          deleteInnerSettle({ id: e.id }).then(res => {
            this.tableLoading = false;
            if (res.code == 1001) {
              this.gettableData();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => {});
    },
    /* 查看结算单详情 */
    show(low) {
      let _this = this;
      _this.low = low;
      _this.createtype = low.contractTypeId;
      console.log(low, _this.createtype);
      _this.billDetails = [];
      this.daochuFlag = true;
      this.downloadId = low.id;
      look_unitinternal({ id: low.id }).then(res => {
        if (res.code == 1001) {
          _this.contract = res.data.contract;
          _this.statements = res.data.statements;
          var billDetails = _this.copy(res.data.detailMap);
          this.engineeringList = [];
          for (let key in billDetails) {
            this.engineeringList.push({ engineeringId: billDetails[key][0].engineeringId, engineeringName: billDetails[key][0].engineeringName });
            billDetails[key].forEach(r => {
              r.settleStartTime = _this.statements.settleStartTime;
              r.settleEndTime = _this.statements.settleEndTime;
              r.contractName = key;
            });
            if (_this.createtype == 1) {
              let item = { contractName: key, data: billDetails[key] };
              _this.billDetails.push(item);
            } else if (_this.createtype == 2) {
              let items = billDetails[key][0];
              _this.billDetails.push(items);
            }
          }
          _this.deductionList = res.data.adjustList;
          _this.deductionListCopy = JSON.parse(JSON.stringify(res.data.adjustList));
          _this.stationList = res.data.stationList;
          if (res.data.stationList.length == 0) {
            _this.deductionList.forEach(e => {
              _this.stationList.push({
                station: e.station,
                stationId: e.stationId,
              });
            });
          }
          _this.billDeta = true;
          // _this.cansave = false
          console.log(_this.billDetails);
        }
      });
    },

    /* 保存结算单 */
    combinedSubmit() {
      //调整金额 数据处理开始
        let deductionList = [];
        let update = this.deductionList.filter(res => this.deductionListCopy.some(item => res.id == item.id));
        let deleteData = this.deductionListCopy.filter(res => !update.some(item => res.id == item.id));
        deleteData.forEach(res => {
          res.dateType = 2; //2是删除
        });
        let addData = this.deductionList.filter(
          //新增的type默认写死为 0
          res => !update.some(item => res.id == item.id)
        );
        deductionList = [...update, ...deleteData, ...addData];
        //调整金额 数据处理结束
      let detailsList = [];
      // let list = this.selectItemList
      let adjustList = deductionList;
      let internalContractId = this.tableParam.internalContractId;
      let innerStatements = { ...this.statements, ...this.totalList[0] };
      if (this.createtype == 1) {
        this.billDetails.forEach(i => {
          i.data.forEach(v => {
            detailsList.push(v);
          });
        });
      } else if (this.createtype == 2) {
        this.billDetails.forEach(i => {
          detailsList.push(i);
        });
      }
      let data = {
        internalContractId: internalContractId,
        innerStatements: innerStatements,
        // list: this.resAllList,
        detailsList: detailsList,
        adjustList: adjustList,
      };
      console.log(data);
      if (this.saveFlag) {
        this.saveFlag = false;
        save_unitinternal(data).then(res => {
          this.saveFlag = true;
          if (res.code == 1001) {
            if (this.currenindex == 3) {
              this.gettableData();
            }
            this.billDeta = false;
            this.deductionList = this.$options.data().deductionList;
            this.$message({
              message: "操作成功",
              type: "success",
            });
            let datas = {
              innerStatements: res.data.statements,
              list: this.resAllList,
              internalContractId: internalContractId,
            };
            saveAlreadyFine(datas).then();
          }
        });
      }
    },

    /**判断时间必传*/
    pagesgettableData() {
      if (this.datePicker && this.datePicker.length !== 0 && this.currenindex === 1) {
        this.gettableDataex();
        return;
      } else if (this.datePicker && this.datePicker.length !== 0 && this.currenindex === 2) {
        this.gettableData();
        return;
      }
      this.$message({
        message: "警告哦，请先选择时间段后查询",
        type: "warning",
      });
    },

    /*导航栏切换*/
    choose(num) {
      this.currenindex = num;
    },

    /**结算合计*/
    settotalList: _debounce(function () {
      this.totalList[0].firstParty = this.contract.firstParty;
      this.totalList[0].secondParty = this.contract.secondParty;
      this.totalList[0].money = this.productallcost();
      this.totalList[0].isAdjustCost = this.combined3(2);
      this.totalList[0].noAdjustCost = this.combined3(3);
      this.totalList[0].totalCost = this.combinedall(1);
      this.totalList[0].ticketCost = this.combinedall(2);
    }),

    /*结算金额合计type:1结算金额2开票金额 */
    combinedall(type) {
      let num = 0;
      let row = this.totalList[0];
      let totalCost = 0;
      if (type == 1) {
        num = totalCost + Number(row.money) + Number(row.isAdjustCost) + Number(row.noAdjustCost);
      } else if (type == 2) {
        num = totalCost + Number(row.money) + Number(row.isAdjustCost) + Number(row.noAdjustCost) - Number(row.noAdjustCost);
      }
      return num.toFixed(2);
    },

    /* 生成结算单 */
    unitsettlement() {
      // contractTypeId = 1: 购销  contractTypeId = 2：代加工
      var _this = this;
      _this.cansave = true;
      // let contractTypeIds = [];
      let contractTypeId = this.contractTypeId;
      this.daochuFlag = false;
      console.log("this.pageAll.length", this.pageAll.length);
      if (this.selectItemList && this.selectItemList.length != 0) {
        this.selectItemList.forEach(e => {
          this.pageAll = this.pageAll.filter(item => {
            if (item.id != e.id) return true;
          });
          console.log(this.pageAll.length);
        });
      }
      this.tableLoading = true;
      if (contractTypeId == 1) {
        _this.billDetails = [];
        _this.createtype = 1;
        let tableParam = {};
        tableParam.internalContractId = this.tableParam.internalContractId;
        tableParam.innerStatements = this.intervalchooseitem;
        tableParam.innerStatements.settleStartTime = this.datePicker[0];
        tableParam.innerStatements.settleEndTime = this.datePicker[1];
        tableParam.list = this.pageAll;
        console.log(tableParam);
        create_unitinternal(tableParam).then(res => {
          console.log(res);
          this.tableLoading = false;
          if (res.code == 1001) {
            console.log(res.data);
            // this.billDetails = res.data.detailMap
            this.deductionList = [];
            res.data.adjustList?.forEach(item => {
              let obj = {
                adjustModule: item.adjustModule,
                deductionType: item.deductionType,
                adjustMoney: item.adjustMoney,
                isInvoice: item.isInvoice,
                type: item.type,
                remark: item.remark,
                station: item.station,
                stationId: item.stationId,
                engineeringId: item.engineeringId,
                engineeringName: item.engineeringName,
                productName: item.productName,
                productPrice: item.productPrice,
                adjustCount: item.adjustCount,
              };
              this.deductionList.push(obj);
            });
            this.contract = res.data.contract;
            this.statements = res.data.statements;
            this.resAllList = res.data.list;
            var billDetails = _this.copy(res.data.detailMap);
            this.stationList = res.data.stationList;
            this.engineeringList = [];
            for (let key in billDetails) {
              this.engineeringList.push({ engineeringId: billDetails[key][0].engineeringId, engineeringName: billDetails[key][0].engineeringName });
              billDetails[key].forEach(r => {
                r.settleStartTime = _this.statements.settleStartTime;
                r.settleEndTime = _this.statements.settleEndTime;
                r.contractName = key;
              });
              let item = { contractName: key, data: billDetails[key] };
              _this.billDetails.push(item);
              console.log(_this.billDetails);
            }
            _this.billDeta = true;
          }
        });
      } else if (contractTypeId == 2) {
        //代加工
        _this.billDetails = [];
        _this.createtype = 2;
        let tableParam = {};
        tableParam.internalContractId = this.tableParam.internalContractId;
        tableParam.innerStatements = this.intervalchooseitem;
        tableParam.innerStatements.settleStartTime = this.datePicker[0];
        tableParam.innerStatements.settleEndTime = this.datePicker[1];
        tableParam.list = this.pageAll;
        create_unitinternal(tableParam).then(res => {
          console.log(res);
          this.tableLoading = false;
          if (res.code == 1001) {
            console.log(res.data);
            this.deductionList = [];
            res.data.adjustList?.forEach(item => {
              let obj = {
                adjustModule: item.adjustModule,
                deductionType: item.deductionType,
                adjustMoney: item.adjustMoney,
                isInvoice: item.isInvoice,
                type: item.type,
                remark: item.remark,
                station: item.station,
                stationId: item.stationId,
                engineeringId: item.engineeringId,
                engineeringName: item.engineeringName,
                productName: item.productName,
                productPrice: item.productPrice,
                adjustCount: item.adjustCount,
              };
              this.deductionList.push(obj);
            });
            this.stationList = res.data.stationList;
            this.contract = res.data.contract;
            this.statements = res.data.statements;
            this.resAllList = res.data.list;
            var billDetails = _this.copy(res.data.detailMap);
            this.engineeringList = [];
            for (let key in billDetails) {
              // this.engineeringList.push({ engineeringId: billDetails[key][0].engineeringId, engineeringName: billDetails[key][0].engineeringName });
              billDetails[key].contractName = key;
              let item = billDetails[key];
              this.billDetails.push(item);
              console.log("_this.billDetails", _this.billDetails);
            }
            _this.billDeta = true;
          }
        });
      }
      // this.$message({
      //   message: "警告哦，请先勾选生成结算单的合同订单哦",
      //   type: "warning",
      // });
    },
    internalListDio() {
      if (this.currenindex == 1) {
        this.inetrnalDio = true;
      } else if (this.currenindex == 2) {
        this.inetrnalDio2 = true;
      } else if (this.currenindex == 3) {
        this.inetrnalDio2 = true;
      }
    },
    confirmChoose() {
      this.templateSelection = `${this.intervalchooseitem.code} ${this.intervalchooseitem.firstParty} ${this.intervalchooseitem.secondParty}`;
      this.inetrnalDio = false;
      this.inetrnalDio2 = false;
      this.contractTypeId = this.intervalchooseitem.contractTypeId;
    },
    singleElection(row) {
      this.intervalchooseitem = row;
    },

    /**调整金额*/
    addItem1() {
      let obj = {
        adjustModule: "",
        deductionType: "",
        adjustMoney: "",
        isInvoice: 0,
        type: "",
        remark: "",
        station: "",
        stationId: "",
        engineeringId: "",
        engineeringName: "",
        productName: "",
        productPrice: "",
        adjustCount:"",
        dateType:0,
      };
      this.deductionList.push(obj);
    },
    delItem1(index) {
      this.deductionList.splice(index, 1);
    },

    /*重置查询条件*/
    init() {
      this.tableData = [];
      this.templateSelection = "";
      this.datePicker = [];
      this.senddatePicker = [];
      if (this.currenindex == 1) {
        this.tableParam = { ...this.$options.data().tableParam, internalContractId: "", startProTime: "", endProTime: "" };
      } else if (this.currenindex == 2) {
        this.tableParam = { ...this.$options.data().tableParam, contractId: "", settleStartTime: "", settleEndTime: "" };
      } else if (this.currenindex == 3) {
        this.tableParam = { ...this.$options.data().tableParam, balanceNo: "", contractId: "", settleStartTime: "", settleEndTime: "" };
      }
    },

    /**结算补差合计*/
    // combined2(item, arr) {
    //   // let num = 0;
    //   console.log(item,arr)
    //   // arr.forEach(res => {
    //   //   num = Number(res.compensateAmount) + num;
    //   // });
    //   // return num.toFixed(2);
    // },

    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableDataex();
    },

    changeSizes() {
      this.tableParam.pageSize = this.curElPage;
      this.gettableDataex();
    },

    /**签收数量计算合计*/
    combined(arr) {
      let num = 0;
      console.log(arr);
      arr.forEach(res => {
        num = Number(res.quantity) + num;
      });
      return num.toFixed(2);
    },

    /**产品费用合计*/
    combined2(arr) {
      let num = 0;
      console.log(arr);
      arr.forEach(res => {
        num = (Number(res.productPrice || 0) + Number(res.addPrice || 0)) * Number(res.quantity) + num;
      });
      return num.toFixed(2);
    },

    /* 产品费用总额计算 */
    productallcost() {
      let num = 0; //此处判断代加工和购销 进行产品费用合计计算
      if (this.createtype == 1) {
        this.billDetails.map(item => {
          item.data.forEach(i => {
            num = (Number(i.productPrice || 0) + Number(i.addPrice || 0)) * Number(i.quantity) + num;
          });
        });
      } else if (this.createtype == 2) {
        this.billDetails.map(item => {
          // num = Math.round((Number(item.processPrice) * Number(item.quantity)) * 100) / 100 + num;
          num = Number(item.processPrice) * Number(item.quantity) + num;
        });
      }
      return num.toFixed(2);
    },

    /* 调价金额总额计算 */
    editmoney() {
      let num = 0;
      this.deductionList.forEach(i => {
        num = num + Math.round(Number(i.adjustMoney));
      });
      return num.toFixed(2);
    },

    /*调整金额合计type:1全部,2影响开票金额合计,3不影响开票金额合计 */
    combined3(type) {
      let num = 0;
      this.deductionList.forEach(res => {
        if (type == 1) {
          num = res.type ? num - Number(res.adjustMoney) : num + Number(res.adjustMoney);
        } else if (type == 2) {
          if (res.isInvoice == 1) {
            num = res.type ? num - Number(res.adjustMoney) : num + Number(res.adjustMoney);
          }
        } else if (type == 3) {
          if (res.isInvoice == 0) {
            num = res.type ? num - Number(res.adjustMoney) : num + Number(res.adjustMoney);
          }
        }
      });
      return num.toFixed(2);
    },

    pageshandleSelectionChange(e) {
      this.selectItemList = e;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo {
  padding: 20px 20px 0 20px;
  max-height: 400px;
  overflow: auto;
}

.tabtop {
  width: 571px;
}

.el-input,
.el-select {
  width: 240px;
}

/*
 <el-link class="table_link" :underline="false">查看配合比</el-link>*/
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.5;
}

.bill_top {
  display: flex;
  justify-content: space-between;

  .text {
    font-weight: 600;
    color: #000;
  }
}

.bill_title {
  font-size: 18px;
  font-weight: 600;
  padding: 15px 0;
}

.bill_title1 {
  font-size: 18px;
  font-weight: 600;
  padding-top: 15px;
}

.bill_subtitle {
  padding: 20px 0;

  > span {
    padding-right: 20px;
  }

  .text {
    color: #000;
  }
}

.combined {
  border: 1px solid #ebeef5;
  text-align: center;
  line-height: 40px;
}

#dyBox {
  padding: 30px;

  > div {
    border: 1px solid #ccc;
    padding: 35px;

    .top {
      > div:nth-of-type(1) {
        font-size: 30px;
        font-weight: 800;
        text-align: center;
        letter-spacing: 35px;
        font-family: "LiSu";
      }

      > div:nth-of-type(2) {
        padding-top: 20px;
        padding-left: 335px;
        font-size: 14px;

        > div:nth-of-type(2) {
          margin-top: 20px;
          letter-spacing: 14px;

          > span {
            margin-left: 5px;
          }
        }

        span {
          letter-spacing: normal;
          display: inline-block;
          margin-left: 30px;
          font-size: 14px;
        }
      }

      > div:nth-of-type(3) {
        padding: 5px 0 5px 0;

        > span {
          font-size: 14px;
          width: 350px;
          display: inline-block;
        }
      }
    }

    .formBox {
      margin-top: 10px;

      > div {
        display: flex;

        > div {
          flex: 1;
          display: flex;
          margin-top: 30px;
          line-height: 10px;

          > .table {
            width: 110px;
            text-align: justify;

            span {
              display: inline-block;
              width: 100%;
            }
          }

          > span:nth-of-type(2) {
            text-align: center;
            margin-left: 5px;
            flex: 1;
            border-bottom: 1px solid #0a0a0a;
          }
        }

        > div:nth-of-type(1) {
          margin-right: 70px;
        }
      }
    }

    .tableBox {
      > div:nth-of-type(1) {
        margin-top: 70px;
        margin-bottom: 40px;
        font-size: 30px;
        font-weight: 800;
        text-align: center;
        letter-spacing: 35px;
        font-family: "LiSu";
      }
    }
  }
}
</style>

